import type { HeaderFooterContentProps } from '@/components/page-sections/types';
import type { SocialLink } from '@/components/shared/social-media';

/**
 * Page footer section variants.
 */

export enum FooterVariant {
  DEFAULT = 'default',
  SIMPLE = 'simple',
  MINIMAL = 'minimal',
  CENTERED = 'centered',
}

export type FooterVariantType = (typeof FooterVariant)[keyof typeof FooterVariant];

// TODO: Reduce footer layout sizes across variants after getting update confirmation on Figma
export interface FooterVariantProps
  extends Omit<HeaderFooterContentProps, 'primaryButton' | 'secondaryButton'> {
  socialLinks?: SocialLink[];
  showText: boolean;
  showNavigationLinks: boolean;
  showUniversalDisclaimer: boolean;
  text?: string;
  socialMediaHeading?: string;
  settings: {
    paddingClass: string;
    spacingClass: string;
  };
}
